export const colors = {
     available : {background:"#C3CFD9", border:"#7B8B99"},
     selected : {background:"#1AAE9E" , border:"#0E7D71"},
     unavailable : {background:"#F7C52B", border:"#FBE192"}
}
